import { disposeCallsApi } from '@gem/call/WsApi/wsCallsApi/WsCallsApi';
import { logger } from '@gem/modules/logger';

import Tasks from 'APP/Tasks';
import { dispatchRealtimeEvents } from 'APP/Tasks/realtimeEvent/realTimeEvents';
import { logout as apiLogout } from 'APP/model/auth/authModel';
import { storage } from 'APP/packages/storage';
import { setSseConfig } from 'APP/packages/streamApi';
import { bffRestClient } from 'APP/restApi/restClient/restClient';
import { wsApiDisconnect } from 'APP/wsApi/wsApi';
import { setWebsocketConfig } from 'APP/wsApi/wsApi.config';
import { ProjectInstallationType } from 'CONFIG_TYPES';
import { MlsStorageService } from 'SERVICES/mlsStorageService/MlsStorageService';
import { WebCryptoService } from 'SERVICES/webCryptoService/WebCryptoService';
import Entities from 'STORE';
import { checkIsCurrentInstallationType } from 'UTILS/checkIsCurrentInstallationType';

async function request(accessToken: string): Promise<void> {
  try {
    await apiLogout({ refreshToken: storage.refreshToken.get(), accessToken });
  } catch (error) {
    logger.get('API').error('authorization.logout', error);
  }
}

export async function logout(resetNotification = false, clearMlsStorage?: boolean): Promise<void> {
  if (Entities.pushNotifications.isEnabled && resetNotification) {
    await Tasks.pushNotifications.unsubscribeNotifications();
    await Tasks.pushNotifications.clearNotifications();
  }

  const ongoingCall = Entities.Calls.ongoingCall;

  if (ongoingCall?.channelId || ongoingCall?.groupId) {
    await Entities.Calls.delete(ongoingCall.groupId, ongoingCall.channelId);
  }

  Tasks.feedback.resetFeedbackStorage();
  Tasks.userSettings.resetRewardsStorage();

  bffRestClient.abortAllRequests();

  await request(Entities.authStore.session || '');
  setWebsocketConfig({ token: null });
  setSseConfig({ token: null });
  dispatchRealtimeEvents();
  wsApiDisconnect();
  disposeCallsApi();

  if (!checkIsCurrentInstallationType([ProjectInstallationType.OnPremiseOnly])) {
    storage.tenantRouting.remove();
    Tasks.config.resetHostConfig();
  }

  storage.refreshToken.remove();

  Entities.reset();

  if (clearMlsStorage) {
    MlsStorageService.clearStorages();
    WebCryptoService.clearStorages();
  }
}
